import { Directive, ElementRef, HostListener, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appHires]',
  standalone: true
})
export class HiresDirective implements OnChanges, OnDestroy {
  @Input() appHires?: string;
  private processedSrc?: string;
  private isUpdating = false;
  private breakpointSubscription: Subscription | null = null;
  private currentBreakpoint: 'mobile' | 'tablet' | 'desktop' = 'mobile';

  constructor(
    private elementRef: ElementRef<HTMLImageElement>,
    private breakpointObserver: BreakpointObserver
  ) {
    // Subscribe to breakpoint changes
    this.breakpointSubscription = this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.Tablet, Breakpoints.Web])
      .subscribe(result => {
        if (result.matches) {
          if (result.breakpoints[Breakpoints.HandsetPortrait]) {
            this.currentBreakpoint = 'mobile';
          } else if (result.breakpoints[Breakpoints.Tablet]) {
            this.currentBreakpoint = 'tablet';
          } else {
            this.currentBreakpoint = 'desktop';
          }
          // Update image source when breakpoint changes if we already have an image
          if (this.appHires) {
            this.updateImageSource();
          }
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['appHires'] && !this.isUpdating) {
      this.updateImageSource();
    }
  }

  ngOnDestroy() {
    // Clean up the subscription when the directive is destroyed
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
      this.breakpointSubscription = null;
    }
  }

  @HostListener('load')
  load() {
    if (!this.isUpdating && this.elementRef.nativeElement.src !== this.processedSrc) {
      this.updateImageSource();
    }
  }

  private updateImageSource() {
    if (!this.appHires || this.appHires === this.processedSrc) {
      return;
    }

    this.isUpdating = true;

    const isServingUrl = this.appHires.includes("lh3.googleusercontent.com");

    if (!isServingUrl) {
      this.elementRef.nativeElement.src = this.appHires;
      this.processedSrc = this.appHires;
      this.isUpdating = false;
      return;
    }

    // Apply different width parameters based on current breakpoint
    let widthParam = 'w600';
    if (this.currentBreakpoint === 'tablet') {
      widthParam = 'w1024';
    } else if (this.currentBreakpoint === 'desktop') {
      widthParam = 'w1152';
    }

    const newSrc = `${this.appHires}=${widthParam}-nu`;

    this.elementRef.nativeElement.src = newSrc;
    this.processedSrc = newSrc;

    this.isUpdating = false;
  }
}
